import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TablesUpdate } from '@/_constants/database.types';

const useUpdateTutorialSeen = () => {
  const client = supabaseClient;
  const queryClient = useQueryClient();

  const mutationFn = async () => {
    return updateTutorialSeen(client);
  };

  return useMutation({
    mutationFn,
    onSuccess: async () => {
      // Invalidate and refetch user data
      await queryClient.invalidateQueries({ queryKey: ['user'] });
      await queryClient.refetchQueries({ queryKey: ['user'] });
    },
  });
};

export default useUpdateTutorialSeen;

async function updateTutorialSeen(client: SupabaseClient): Promise<void> {
  const {
    data: { user },
  } = await client.auth.getUser();

  if (!user) {
    throw new Error('User not authenticated');
  }

  const updateData: TablesUpdate<'users'> = {
    tutorial_seen: true,
  };

  const { error } = await client.from('users').update(updateData).eq('auth_id', user.id);

  if (error) {
    throw new Error(error.message);
  }
}
